import { useTranslation } from "react-i18next";
import { Box, Tooltip, Typography } from "@material-ui/core";
import { orange } from "@material-ui/core/colors";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

import { StyledFab } from "../Styled";

import { Rule } from "@dashboard-v3/api";
import { getCloudStorage as getStorage } from "pages/Rules/Form/context/ruleSelectors";

export default function IndividualStorageFeedback({ rule }: { rule: Rule }) {
  const { t } = useTranslation("rules");
  const storage = getStorage(rule);
  const isIndividualStorage =
    storage?.authentication === "INDIVIDUAL" &&
    storage?.provider !== "DROPBOX" &&
    storage?.provider !== "EGNYTE" &&
    storage?.provider !== "EGNYTE_GOV";

  if (!isIndividualStorage) return null;

  return (
    <Tooltip
      arrow
      style={{ maxWidth: "none" }}
      placement="top"
      title={
        <Typography variant="caption">
          {t("cloudStorage.individualWarning.helper")}
        </Typography>
      }
    >
      <Box mr={1}>
        <StyledFab color="default" size="small">
          <WarningRoundedIcon
            fontSize="small"
            style={{ color: orange[500], marginBottom: 3 }}
          />
        </StyledFab>
      </Box>
    </Tooltip>
  );
}
